// extracted by mini-css-extract-plugin
export default {"container":"Error_container__nT1F5","btn":"Error_btn__lvWVO"};